const qb = require('./querybuilder.js')

module.exports = {
  card: qb('cards'),
  set: qb('sets')
}
